import L from "leaflet";
import "leaflet-rotatedmarker";
import MarkerClusterGroup from "react-leaflet-cluster";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useEffect, useState, useRef } from "react";
const planeIcon = L.icon({
  iconUrl: "/1766262022155.png",
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});
const outerBounds = [
  [-90, -180],
  [90, 180],
];
function Searchc({ search, markersRef }) {
  const map = useMap();
  useEffect(() => {
    const searchterm=search?.trim();
    if (search && markersRef.current[searchterm]) {
      const marker = markersRef.current[searchterm];
      const { lat, lng } = marker.getLatLng();
      map.flyTo([lat, lng], 8, { duration: 2 });
      marker.openPopup();
    }
  }, [search, map]);
  return null;
}

function FlightMap({flight, search}) {
  const markersRef = useRef({});
  const [f, setf] = useState([[1, 1]]);
  useEffect(() => {
    setf(flight.flight);
  }, [flight]);
  return (
    <MapContainer
      preferCanvas={true}
      center={[33.5138, 36.2765]}
      zoom={1}
      minZoom={2.5}
      maxZoom={20}
      maxBounds={outerBounds}
      maxBoundsViscosity={1.0}
      style={{ height: "100%", width: "100%" }}
    >
      <Searchc search={search} markersRef={markersRef} />
      <MarkerClusterGroup chunkedloading>
        {f &&
          f.slice(0, 1000).map((e) => {
            if (e[5] !== null && e[6] !== null) {
              return (
                <Marker
                  key={e[0]}
                  position={[e[6], e[5]]}
                  icon={planeIcon}
                  rotationAngle={(e[10] || 0) - 45}
                  rotationOrigin="center"
                  ref={(ref) => {
                    if (ref) {
                      console.log(e[0])
                      markersRef.current[e[0]] = ref;

                    }
                    else{delete markersRef.current[e[0]]}
                  }}
                >
                  <Popup>
                    <p>icao24 : {e[0]}</p>
                    <p>callsign : {e[1]}</p>
                    <p>origin country : {e[2]} </p>
                    <p>longitude : {e[5]}</p>
                    <p>latitude : {e[6]}</p>
                    <p>baro_altitude : {e[7]}</p>
                    <p>velocity : {e[9]}</p>
                  </Popup>
                </Marker>
              );
            }
          })}
      </MarkerClusterGroup>
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        bounds={outerBounds}
        noWrap={true}
      />
    </MapContainer>
  );
}

export default FlightMap;
